import { ref, reactive, Ref } from 'vue'
import Index from './Index.vue'

export default Index

export interface TeamHeadInst {
  setDropdownVisible(visible: boolean): void
}

type paramsType = {
  showTeamMemberEntry: Ref<boolean>
  isVisitor: Ref<boolean>
  isLogin: Ref<boolean>
  stickyGroupPanel: Ref<boolean>
  hiddenTeamSpace: Ref<boolean>
  hiddenTeamMember: Ref<boolean>
  hiddenShareBtn: Ref<boolean>
  hiddenMessageAlert: Ref<boolean>
  isEase: Ref<boolean>
  showLoginBtn?: Ref<boolean>
  showSpaceEnterGuide?: Ref<boolean>
}

export const useTeamHead = ({
  showTeamMemberEntry,
  isVisitor,
  isLogin,
  stickyGroupPanel,
  hiddenTeamSpace,
  hiddenTeamMember,
  hiddenShareBtn,
  hiddenMessageAlert,
  isEase,
  showLoginBtn,
  showSpaceEnterGuide
}: paramsType) => {
  const props = ref({
    showTeamMemberEntry,
    isVisitor,
    isLogin,
    stickyGroupPanel,
    hiddenTeamSpace,
    hiddenTeamMember,
    hiddenShareBtn,
    hiddenMessageAlert,
    isEase,
    showLoginBtn,
    showSpaceEnterGuide
  })
  return reactive({
    props
  })
}
